/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Addemail1Inputs */

const en_settings_addemail1 = /** @type {(inputs: Settings_Addemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add email`)
};

/**
* | output |
* | --- |
* | "Add email" |
*
* @param {Settings_Addemail1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_addemail1 = /** @type {((inputs?: Settings_Addemail1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Addemail1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_addemail1(inputs)
});
export { settings_addemail1 as "settings_addEmail" }